import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Select from '../../../../../../components/Select';
import t from '../../../../../../lib/translate';
import { getTemplateFormats } from '../../../../../../api';
var TemplateFormatSelector = function (props) {
    var _a = useState([]), formats = _a[0], setFormats = _a[1];
    var onChange = props.onChange;
    useEffect(function () {
        if (formats) {
            onChange(formats[0]);
        }
    }, [formats, onChange]);
    useEffect(function () {
        getTemplateFormats().then(function (res) { return setFormats(res); });
    }, []);
    return (_jsx(Select, { label: t('templates.edit.template.format'), onChange: function (format) {
            // @ts-ignore
            onChange(format.value);
        }, options: formats.map(function (format) { return ({ value: format, label: format }); }) }));
};
export default TemplateFormatSelector;
